import Vue from 'vue'
import LoginAPI from '@/api/LoginAPI'
import GuideAPI from '@/api/GuideAPI'
import VueYouTubeEmbed from 'vue-youtube-embed'
import CustomAlert from '@/plugins/sweetAlert'
import i18n from './plugins/i18n'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// import auth from './firebase'

import '@/assets/css/reset.css'
import '@/assets/css/system.css'
import '@/assets/css/terms.css'
import '@/assets/css/custom.css'

Vue.config.silent = true
Vue.config.productionTip = false

Vue.use(VueYouTubeEmbed)
Vue.use(LoginAPI)
Vue.use(GuideAPI)
Vue.use(CustomAlert)

// auth.onAuthStateChanged((user) => {
//   store.dispatch('fetchUser', user)
// })

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
